import React from 'react';
import { Link } from "react-router-dom";
import '../assets/css/careers.css';

export default class OurPeople extends React.Component {
    render() {
        return (
            <div>
                {/* <div className='career-cont'>
                    <header className="preheader">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="card values">
                                        <div className="row">
                                            <div className="col-sm-4 col-md-4 val">
                                                <div className="info">
                                                    <h4 className="bold deep-blue-text">Our Group</h4>
                                                    <p>FSDH Holding Company Limited is a non-operating holding company focused on the provision of progressive financial services in Nigeria. Our robust portfolio of subsidiaries have enabled us offer a diversified range of financial products and services across the country. Looking ahead, we aim to deepen our current business lines and expand our offerings, to maintain status as the one-stop-shop for dependable and innovative financial services in the region. Looking ahead, we aim to deepen our current business lines and expand our offerings, to maintain status as the one-stop-shop for dependable and innovative financial services in the region. Looking ahead, we aim to deepen our current business lines and expand our offerings, to maintain status as the one-stop-shop for dependable and innovative financial services in the region.</p>
                                                </div>
                                            </div>
                                            <div className="col-sm-4 col-md-4 val">
                                                <div className="info">
                                                    <h4 className="bold deep-blue-text">Our Leadership</h4>
                                                    <p>FSDH Merchant Bank is an organisation that places a strong emphasis on its people. The employees are encouraged to be innovative while being client focused and to take extreme ownership while dealing with the business.  FSDH Merchant Bank has a strong team of financial experts that provide we are on hand advice to help inform your financial choices, while ensuring the final decision is always yours.</p>
                                                    <Link to="/people" className="gray-bordered-button-sm">Read more</Link>
                                                </div>
                                            </div>
                                            <div className="col-sm-4 col-md-4 val">
                                                <div className="info">
                                                    <h4 className="bold deep-blue-text">Our Story</h4>
                                                    <p>First Securities Discount House Limited, the precursor to FSDH Merchant Bank Limited, was incorporated in June 1992 as the first discount house to operate in Nigeria. In the new era, FSDH Merchant Bank Limited was one of the first merchant banks to be granted a licence to operate in Nigeria as a merchant bank.
                                                    </p>
                                                    <Link to="/about" className="gray-bordered-button-sm">Read more</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="card full-card service-card burgundy-bg">
                                        <div className="column white-text">
                                            <span>CAREERS</span>
                                            <div className="card-body">
                                                <p className="block-heading">The FSDH Culture</p>

                                                <Link to="/culture" className="white-button-sm">Read More</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>
                </div> */}
                
                <div className="about">
                <div className="body white-text"  style={{background: 'var(--fsdh-deep-blue)'}}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-8">
                                    <h2 className="bold">Our People</h2>
                                    <p></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-7 col-xl-7">
                                    {/* <h2 className="bold">Our People</h2> */}
                                    <p>
                                    Our employees are our most important assets. Their commitment, collaboration, and engagement are why we deliver true value, and create enduring wealth, for our stakeholders.
                                    </p>
                                    <p>
                                    Our people remain key to the successful implementation of the FSDH culture. They encompass the totality of our shared attitudes, values, practices and goals.
                                    </p>
                                    <p>
                                    With increasing competition worldwide, attracting and retaining the best talent has never been more important. As such, we place great emphasis on the development of our people through our strategic human resources agenda- a decision that has proven excellent thus far.
                                    </p>
                                    <p>
                                    Over the years, competition has tried to replicate our systems and processes to no avail because whilst our products and services can be emulated, the FSDH person – unique and inimitable – cannot. The FSDH person is professional, research- oriented, proactive, analytical and passionate about value addition. We recognise that our human resources are a major contributing factor to the services we render.
                                    </p>
                                    <p>
                                    For this reason, FSDH has developed its innate culture where all members of staff are encouraged to conduct themselves in accordance with the main principles of open communication, courage, zeal, leadership, knowledge, simplicity and pride– principles on which the FSDH culture was developed.
                                    </p>
                                    <p>
                                    In a bid to ensure that this culture is enshrined in our daily lives at FSDH, several initiatives are designed and undertaken. One of such initiatives is to identify members of staff who have consistently exhibited these values and celebrate them as role models. Each year, since 1999, we have recognised and celebrated the “FSDH Person of the year” in Senior and Junior Categories.
                                    </p>
                                    <p>
                                    We encourage each and every one of our employees to engage and participate in our Corporate Social Responsibility programmes, demonstrating in a tangible way how FSDH Merchant Bank and its employees work together to combine a culture of performance with a culture of responsibility.
                                    </p>
                                    <br />
                                </div>
                                <div className='d-sm-none d-md-block col-md-1 col-xl-2'></div>
                                <div className="col-md-4 col-xl-3">
                                    <div className="card black-text">
                                        <p className="bold">Mission</p>
                                        <hr />
                                        <p>
                                        Improving outcomes for our customers and subsidiaries while delivering value for our shareholders.
                                        </p><br />

                                        <p className="bold">Vision</p>
                                        <hr />
                                        <p>
                                        To be a top aggregator of financial assets in Nigeria
                                        </p><br />

                                        <p className="bold">Credit Rating</p>
                                        <hr />
                                        <p>The rating assigned to FSDH Merchant Bank Limited (‘FSDH’ or ‘the Bank’) is underpinned by good capitalization, good liquidity, good profitability and an experienced management team.<br /><br />
                                        <a href="/creditrating" className="gray-bordered-button-sm">Read more</a>
                                        </p><br />

                                        <p className="bold">Locations</p>
                                        <hr />
                                        <p>
                                        FSDH Merchant Bank provides a connection for our partners to services in Corporate and Investment Banking in Africa in these locations.<br /><br />
                                        <a href="/contact" className="gray-bordered-button-sm">Read more</a>
                                        </p><br />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="subsidiaries">
                        <div className="container-fluid">
                            <p className="bold big-para-text">Affiliates</p><br />
                            <div className="row">
                                <div className="col-md-3 col-sm-4">
                                    <p className="bold">FSDH Asset Management</p>
                                    <p>
                                        FSDH Asset Management Limited (FSDH AM) was established
                                        to provide investment advisory and portfolio management
                                        services to clients whose investment horizon.
                                    </p>
                                    <Link to=''>
                                        <span className="dark-blue-text">Visit Site</span>
                                    </Link>
                                </div>
                                <div className="col-md-3 col-sm-4">
                                    <p className="bold">FSDH Securities Limited</p>
                                    <p>
                                        FSDH Securities Limited (FSDH SEC) is a wholly owned
                                        subsidiary of FSDH Asset Management Limited which is
                                        also a subsidiary of FSDH Merchant Bank Limited.
                                    </p>
                                    <Link to=''>
                                        <span className="dark-blue-text">Visit Site</span>
                                    </Link>
                                </div>
                                <div className="col-md-3 col-sm-4">
                                    <p className="bold">Pensions Alliance Limited</p>
                                    <p>
                                        Pensions Alliance Limited is a joint venture between FSDH
                                        Merchant Bank Limited (FSDH MB) and African Alliance Insurance Company Limited.
                                    </p>
                                    <Link to=''>
                                        <span className="dark-blue-text">Visit Site</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}